import { SET_BREADCRUMBS_FACET } from '../../mutation-types';

export function setFacet({ commit }, { facet }) {
    commit(SET_BREADCRUMBS_FACET, { facet });
}
